export default __webpack_public_path__ + "static/media/rok.808f5217.svg";